var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubrik(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 1,
    width: 8,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6685 1.14228L8.65776 4.15301C8.47915 4.34437 8.47915 4.63779 8.65776 4.82915L11.6685 7.83987C11.8598 8.03123 12.1533 8.03123 12.3446 7.83987L15.3553 4.82915C15.5339 4.65054 15.5339 4.34437 15.3553 4.15301L12.3446 1.14228C12.2553 1.05298 12.1277 1.00195 12.0129 1.00195C11.8726 1.00195 11.7578 1.05298 11.6685 1.14228Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 -2.53125L19.0294 4.51079L12.0002 11.5401L4.95813 4.51079L12.0002 -2.53125Z",
    fill: "url(#paint0_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 16,
    width: 8,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6685 16.156L8.65776 19.1667C8.47915 19.3453 8.47915 19.6515 8.65776 19.8428L11.6685 22.8535C11.8598 23.0449 12.1533 23.0449 12.3446 22.8535L15.3553 19.8428C15.5339 19.6515 15.5339 19.358 15.3553 19.1667L12.3446 16.156C12.2553 16.0667 12.1277 16.0156 12.0129 16.0156C11.8726 16.0284 11.7578 16.0667 11.6685 16.156Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 12.4961L19.0294 19.5254L12.0002 26.5674L4.95813 19.5254L12.0002 12.4961Z",
    fill: "url(#paint1_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 8,
    width: 7,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1696 8.64137L16.1589 11.6521C15.9675 11.8435 15.9675 12.1369 16.1589 12.3282L19.1696 15.339C19.361 15.5176 19.6544 15.5176 19.8458 15.339L22.8565 12.3155C23.0478 12.1241 23.0478 11.8307 22.8565 11.6393L19.8458 8.62861C19.7565 8.53931 19.6289 8.48828 19.5141 8.48828C19.3865 8.50104 19.2589 8.55207 19.1696 8.64137Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5014 4.96875L26.5435 12.0108L19.5014 19.0528L12.4722 12.0108L19.5014 4.96875Z",
    fill: "url(#paint2_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 19,
    width: 3,
    height: 4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89209 19.895L6.55258 21.2345C6.36122 21.4131 6.39949 21.6683 6.62912 21.7959L7.77728 22.3444C8.01967 22.4465 8.21103 22.3189 8.21103 22.051V20.0354C8.21103 19.8695 8.16 19.793 8.0707 19.793C8.03243 19.793 7.96864 19.8312 7.89209 19.895Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30504 18.8594L9.55033 21.1174L7.30504 23.3755L5.047 21.1174L7.30504 18.8594Z",
    fill: "url(#paint3_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 19,
    width: 3,
    height: 4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7637 20.0354V22.051C15.7637 22.3062 15.9678 22.4465 16.1974 22.3444L17.3456 21.7959C17.5752 21.6683 17.6135 21.4131 17.4221 21.2345L16.0954 19.895C16.0188 19.8185 15.955 19.793 15.904 19.793C15.8275 19.793 15.7637 19.8823 15.7637 20.0354Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6949 18.8594L18.953 21.1174L16.6949 23.3755L14.4369 21.1174L16.6949 18.8594Z",
    fill: "url(#paint4_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 5,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2357 15.752C15.9678 15.752 15.7637 15.9688 15.7637 16.224V18.9413C15.7637 19.1964 15.9805 19.4133 16.2357 19.4133H18.953C19.2081 19.4133 19.425 19.1964 19.425 18.9413V16.224C19.425 15.9688 19.2081 15.752 18.953 15.752H16.2357Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6008 13.918L21.2622 17.5921L17.6008 21.2534L13.9395 17.5921L17.6008 13.918Z",
    fill: "url(#paint5_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 6,
    width: 4,
    height: 3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2618 6.55232L19.9223 7.89183C19.7437 8.07044 19.7948 8.22352 20.0627 8.22352H22.0783C22.3335 8.22352 22.4738 8.01941 22.3717 7.78978L21.8232 6.64162C21.7466 6.51404 21.6446 6.4375 21.517 6.4375C21.4277 6.4375 21.3384 6.47577 21.2618 6.55232Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0959 5.07031L23.354 7.32836L21.0959 9.5864L18.8379 7.32836L21.0959 5.07031Z",
    fill: "url(#paint6_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 1,
    width: 3,
    height: 4
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7637 1.92349V3.93914C15.7637 4.19429 15.9168 4.25808 16.0954 4.07947L17.4349 2.73995C17.6135 2.56135 17.588 2.30621 17.3583 2.17863L16.2102 1.63007C16.1591 1.60455 16.1081 1.5918 16.0571 1.5918C15.8785 1.5918 15.7637 1.71937 15.7637 1.92349Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6949 0.669922L18.953 2.92797L16.6949 5.18601L14.4369 2.92797L16.6949 0.669922Z",
    fill: "url(#paint7_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 6,
    width: 4,
    height: 3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17677 6.62794L1.62821 7.7761C1.52615 8.01849 1.65372 8.20985 1.92163 8.20985H3.93728C4.19243 8.20985 4.25622 8.05676 4.07761 7.87816L2.7381 6.53864C2.66155 6.4621 2.57225 6.42383 2.48295 6.42383C2.35538 6.43659 2.25332 6.50037 2.17677 6.62794Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89122 5.07031L5.16202 7.32836L2.89122 9.5864L0.633179 7.32836L2.89122 5.07031Z",
    fill: "url(#paint8_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 5,
    height: 5
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04734 4.5625C4.77943 4.5625 4.57532 4.77937 4.57532 5.03452V7.75183C4.57532 8.00697 4.79219 8.22385 5.04734 8.22385H7.76465C8.03255 8.22385 8.23667 8.00697 8.23667 7.75183V5.03452C8.23667 4.77937 8.01979 4.5625 7.76465 4.5625H5.04734Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.39975 2.72852L10.0611 6.38986L6.39975 10.064L2.7384 6.38986L6.39975 2.72852Z",
    fill: "url(#paint9_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 3,
    height: 4
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78997 1.63007L6.64182 2.17863C6.41218 2.30621 6.37391 2.5486 6.56527 2.73996L7.90479 4.07947C8.08339 4.25808 8.23648 4.20705 8.23648 3.93914V1.92349C8.23648 1.71937 8.12166 1.5918 7.95582 1.5918C7.90479 1.5918 7.841 1.60455 7.78997 1.63007Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3051 0.669922L9.56315 2.92797L7.3051 5.18601L5.0343 2.92797L7.3051 0.669922Z",
    fill: "url(#paint10_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 15,
    width: 4,
    height: 3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 15.752C19.8074 15.752 19.7436 15.905 19.9222 16.0836L21.2617 17.4232C21.4403 17.6018 21.6955 17.5635 21.8231 17.3339L22.3716 16.1857C22.4737 15.9433 22.3333 15.752 22.0782 15.752H20.0625V15.752Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0959 14.3848L23.3922 16.6811L21.0959 18.9774L18.7996 16.6811L21.0959 14.3848Z",
    fill: "url(#paint11_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 15,
    width: 5,
    height: 5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04734 15.752C4.77943 15.752 4.57532 15.9688 4.57532 16.224V18.9413C4.57532 19.1964 4.79219 19.4133 5.04734 19.4133H7.76465C8.03255 19.4133 8.23667 19.1964 8.23667 18.9413V16.224C8.23667 15.9688 8.01979 15.752 7.76465 15.752H5.04734Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.39975 13.918L10.0611 17.5921L6.39975 21.2534L2.7384 17.5921L6.39975 13.918Z",
    fill: "url(#paint12_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 15,
    width: 4,
    height: 3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92163 15.752C1.65372 15.752 1.52615 15.9561 1.62821 16.1857L2.17677 17.3339C2.30435 17.5635 2.54674 17.6018 2.7381 17.4232L4.07761 16.0836C4.26897 15.8923 4.20519 15.752 3.93728 15.752H1.92163V15.752Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89135 14.3848L5.18766 16.6811L2.89135 18.9774L0.607788 16.6811L2.89135 14.3848Z",
    fill: "url(#paint13_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 4,
    width: 5,
    height: 5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2357 4.5625C15.9678 4.5625 15.7637 4.77937 15.7637 5.03452V7.75183C15.7637 8.00697 15.9805 8.22385 16.2357 8.22385H18.953C19.2081 8.22385 19.425 8.00697 19.425 7.75183V5.03452C19.425 4.77937 19.2081 4.5625 18.953 4.5625H16.2357Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6008 2.72852L21.2622 6.38986L17.6008 10.064L13.9395 6.38986L17.6008 2.72852Z",
    fill: "url(#paint14_linear_25993_211146)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_25993_211146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 8,
    width: 7,
    height: 8
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15425 8.64228L1.14352 11.653C0.95216 11.8444 0.95216 12.1378 1.14352 12.3291L4.15425 15.3399C4.3456 15.5185 4.63902 15.5185 4.83038 15.3399L7.84111 12.3291C8.01971 12.1378 8.01971 11.8444 7.84111 11.653L4.83038 8.64228C4.74108 8.55298 4.61351 8.50195 4.49869 8.50195C4.37112 8.50195 4.24355 8.55298 4.15425 8.64228Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_25993_211146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.48607 4.96875L11.5281 12.0108L4.48607 19.0401L-2.54321 12.0108L4.48607 4.96875Z",
    fill: "url(#paint15_linear_25993_211146)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25993_211146",
    x1: 8.23162,
    y1: 0.748791,
    x2: 23.2519,
    y2: 15.7691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25993_211146",
    x1: 0.719719,
    y1: 8.25979,
    x2: 15.74,
    y2: 23.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25993_211146",
    x1: 8.23486,
    y1: 0.744114,
    x2: 23.2552,
    y2: 15.7644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25993_211146",
    x1: -2.42104,
    y1: 11.3956,
    x2: 12.5997,
    y2: 26.4163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25993_211146",
    x1: 2.27878,
    y1: 6.69481,
    x2: 17.2996,
    y2: 21.7156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25993_211146",
    x1: 4.49892,
    y1: 4.48459,
    x2: 19.5192,
    y2: 19.5049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25993_211146",
    x1: 11.3756,
    y1: -2.39794,
    x2: 26.3957,
    y2: 12.6222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25993_211146",
    x1: 11.3727,
    y1: -2.39358,
    x2: 26.3929,
    y2: 12.6266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25993_211146",
    x1: 2.27702,
    y1: 6.69873,
    x2: 17.2971,
    y2: 21.7188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_25993_211146",
    x1: 4.4899,
    y1: 4.49469,
    x2: 19.5105,
    y2: 19.5153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_25993_211146",
    x1: 6.67593,
    y1: 2.30232,
    x2: 21.6968,
    y2: 17.3232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_25993_211146",
    x1: 6.70047,
    y1: 2.28197,
    x2: 21.7187,
    y2: 17.3002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_25993_211146",
    x1: -1.10405,
    y1: 10.0892,
    x2: 13.9164,
    y2: 25.1097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_25993_211146",
    x1: -2.4054,
    y1: 11.3861,
    x2: 12.6148,
    y2: 26.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_25993_211146",
    x1: 10.0951,
    y1: -1.1134,
    x2: 25.1155,
    y2: 13.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_25993_211146",
    x1: 0.728771,
    y1: 8.24906,
    x2: 15.7491,
    y2: 23.2694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0577706,
    stopColor: "#04B390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    stopColor: "#0CAFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    stopColor: "#13ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#17AAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#1AA8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA8E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubrik);
export default __webpack_public_path__ + "static/media/Rubrik.f7640e92928ad749855795110d07c1ea.svg";
export { ForwardRef as ReactComponent };